<template>
  <!--
          作者 luoyiming
          时间：2020-06-09
          描述：健康证列表管理
      -->
  <div class="user">
    <!---->
    <div class="common-level-rail">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="报备类型">
          <el-select size="small" v-model="searchForm.type" placeholder="请选择报备类型">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item,index) in typelist" :key='index' :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <el-table-column prop="orderId" label="订单ID" width="200"></el-table-column>

          <el-table-column prop="" label="技师">
            <template slot-scope="scope" v-if="scope.row.orderDetails">
              <span>{{scope.row.orderDetails?scope.row.orderDetails.waiter.username:''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="头像" width="200">
            <template slot-scope="scope" v-if="scope.row.orderDetails">
              <img :src="scope.row.orderDetails.waiter.avatarUrl" width="60px" height="40px" />
            </template>
          </el-table-column>
          <el-table-column prop="images" label="图片材料">
            <template slot-scope="scope">
              <div v-for="(item,index)  in scope.row.images" :key="index">
                <img :src="item" width="60px" height="60px" />
                <!-- <el-image :src="item" alt="" :preview-src-list="[scope.row.images]" width="60px">
                </el-image> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="报备类型">
          </el-table-column>
          <el-table-column prop="content" label="内容"></el-table-column>
          <!-- <el-table-column prop="status" label="是否解决">
            <template slot-scope="scope">
              <div>{{ scope.row.status == 1 ? "已解决" : "未解决" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="reject_reason" label="审核原因" width="400"></el-table-column>
          <el-table-column prop="createTime" label="创建日期" width="150"></el-table-column> -->
          <!-- <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small" :disabled="scope.row.status == 1">审核</el-button>
              <el-button @click="deleteClick(scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import NoticeApi from "@/api/notice.js";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    /*编辑组件*/
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      typelist: [],
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: "",
        region: ""
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      searchForm: {
        type: ""
      }
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*换行*/
    keepTextStyle(val) {
      let str = val.replace(/(\\r\\n)/g, "<br/>");
      return str;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      NoticeApi.getReportList(Params, true)
        .then(data => {
          self.loading = false;
          if (data.code != 1) return;
          this.typelist = data.data.type;
          data.data.list.data.forEach(item => {
            self.typelist.forEach(typeItem => {
              if (item.type == typeItem.id) {
                item.type = typeItem.value;
              }
            });
          });
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/qita/report/index.vue